import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 1.5rem 2rem 2rem;
		border-radius: 1.5rem;
	}

	.ant-modal-header {
		padding: 0;
		border-bottom: none;
	}

	.ant-modal-body {
		padding: 0;
	}

	.ant-modal-title {
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1.5625rem;
		font-weight: 600;
		line-height: 2rem;
		letter-spacing: -0.005em;
	}

	.ant-modal-close {
		top: 1.5rem;
		right: 2rem;
		color: ${({ theme }) => theme.palette.secondary[400]};
	}

	.ant-modal-close-x {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1rem;
		height: 1rem;
		line-height: 1rem;
	}
`;
